import api from '../../../api/api'
import { _orderByName } from '../../../utils/formatter'

export default {
  getSupervisores: async (active = null, resumo = false) => {
    const data = await api.get.centrals(active, resumo)

    return _orderByName({
      data,
      key: 'Nome',
    })
  },
}
